import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MoaksVisitModel} from '../../../../../_models/MOAKS/moaks-visit-model';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SharedService} from '../../moaks-basic-form/shared.service';
import {isNotNullOrUndefined} from "codelyzer/util/isNotNullOrUndefined";
import {MoaksMocartScoringModel} from "../../../../../_models/MOAKS/moaks-mocart-scoring-model";
import {visit} from "@angular/compiler-cli/src/ngtsc/util/src/visitor";
import {AddLesionRequest, GlobalLesionModel, MarkerType, OncologyAddLesionData, OncologyLesionEditType, OncologyLesionType, Snapshot} from 'src/app/_models/Oncology/global-lesion-model';
import {ReadingMoaksService} from "../../../../../_services/reading-moaks.service";
import {forkJoin, Subscription} from "rxjs";
import {ToastService} from "../../../../../_services/internal/toast.service";
import {MessageDialogComponent} from "../../../../../components/controls/message-dialog/message-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-moaks-mocart-scoring-form',
  templateUrl: './moaks-mocart-scoring-form.component.html',
  styleUrls: ['./moaks-mocart-scoring-form.component.css']
})

export class MoaksMocartScoringFormComponent implements OnInit, OnDestroy {

  form: FormGroup;
  mocartFormControl: FormGroup;
  lesionType = OncologyLesionType.TARGET_LESION;

  lesionName1 = 'T01';
  lesionName2 = 'T02';
  lesionNumber1: number = 1;
  lesionNumber2: number = 2;
  currentLesion: number;
  markerType = MarkerType.BI_RULER;
  ruler = MarkerType.RULER;
  addUpdateLesionRequest: OncologyAddLesionData;
  lesionData: any = {
    screenShotData1: {},
    screenShotData2: {}
  };

  screenshotSubscription: Subscription;
  snapshot: Snapshot | null = null;
  snapshot1: Snapshot | null = null;
  snapshot2: Snapshot | null = null;
  originalBaselineReadingId: number | null = null;

  @Output('onAddLesion') onAddLesion: EventEmitter<AddLesionRequest> = new EventEmitter<AddLesionRequest>();

  @Input() reading: any;

  @Input()
  get visit(): MoaksVisitModel {
    return this._visit;
  }

  set visit(visit: MoaksVisitModel) {
    this._visit = visit;
    if (this.form) {
      this.init();
    }
  }

  private _visit: MoaksVisitModel;
  private _baselineVisitConfigId: number;

  @Input()
  get baselineVisitConfigId(): number {
    return this._baselineVisitConfigId;
  }

  set baselineVisitConfigId(baselineVisitConfigId: number) {
    this._baselineVisitConfigId = baselineVisitConfigId;
  }

  @Input() uid: string;

  @Input() clinicalData: string;
  @Output('onValidForm') onValidForm: EventEmitter<{ isValid: boolean; baselineConditionOk: boolean }> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private readingService: ReadingMoaksService,
    private toastService: ToastService,
    private dialogMessagePreview: MatDialog
  ) {
     this.mocartFormControl = new FormGroup({
      // Define form controls and their initial values
       id: new FormControl('', []),
       code: new FormControl('', []),
       region: new FormControl('', []),
       loss: new FormControl('', []),
       lesionLocation: new FormControl('', [Validators.required]),
       volumeOfCartilageDefectFiling: new FormControl('', [Validators.required]),
       volumeOfCartilageDefectFilingScore: new FormControl(0, [Validators.required]),
       integrationAdjacentCartilage: new FormControl('', [Validators.required]),
       integrationAdjacentCartilageScore: new FormControl(0, [Validators.required]),
       surfaceRepairTissue: new FormControl('', [Validators.required]),
       surfaceRepairTissueScore: new FormControl(0, [Validators.required]),
       structureRepairTissue: new FormControl('', [Validators.required]),
       structureRepairTissueScore: new FormControl(0, [Validators.required]),
       signalIntensityRepairTissue: new FormControl('', [Validators.required]),
       signalIntensityRepairTissueScore: new FormControl(0, [Validators.required]),
       bonyDefect: new FormControl('', [Validators.required]),
       bonyDefectScore: new FormControl(0, [Validators.required]),
       subChondralChanges: new FormControl('', [Validators.required]),
       subChondralChangesScore: new FormControl(0, [Validators.required]),
       comment: new FormControl('', []),
       totalMocartScore: new FormControl(0, [Validators.required]),
       icrsGrade: new FormControl('', [Validators.required]),
       notAvailable: new FormControl(false,[]),
       notAvailable1: new FormControl(false,[]),
       notAvailable2: new FormControl(false,[]),
       ladValue: new FormControl(null,[]),
       sadValue: new FormControl(null,[]),
       diameterValue1: new FormControl(null, []),
       diameterValue2: new FormControl(null, []),
    });
    this.form = this.fb.group({
      scorings: this.mocartFormControl
    });
  }

  ngOnDestroy(): void {
    this.setSubmitData();
    if(this.screenshotSubscription) {
      this.screenshotSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.disableCompletedVisit();
    if (this._visit.mocartScorings) {
      this.mocartFormControl.patchValue({
        id: this._visit.mocartScorings.id,
        code: this._visit.mocartScorings.code,
        region: this._visit.mocartScorings.region,
        loss: this._visit.mocartScorings.loss,
        lesionLocation: this._visit.mocartScorings.lesionLocation,
        volumeOfCartilageDefectFiling: this._visit.mocartScorings.volumeOfCartilageDefectFiling,
        volumeOfCartilageDefectFilingScore: this._visit.mocartScorings.volumeOfCartilageDefectFilingScore,
        integrationAdjacentCartilage: this._visit.mocartScorings.integrationAdjacentCartilage,
        integrationAdjacentCartilageScore: this._visit.mocartScorings.integrationAdjacentCartilageScore,
        surfaceRepairTissue: this._visit.mocartScorings.surfaceRepairTissue,
        surfaceRepairTissueScore: this._visit.mocartScorings.surfaceRepairTissueScore,
        structureRepairTissue: this._visit.mocartScorings.structureRepairTissue,
        structureRepairTissueScore: this._visit.mocartScorings.structureRepairTissueScore,
        signalIntensityRepairTissue: this._visit.mocartScorings.signalIntensityRepairTissue,
        signalIntensityRepairTissueScore: this._visit.mocartScorings.signalIntensityRepairTissueScore,
        bonyDefect: this._visit.mocartScorings.bonyDefect,
        bonyDefectScore: this._visit.mocartScorings.bonyDefectScore,
        subChondralChanges: this._visit.mocartScorings.subChondralChanges,
        subChondralChangesScore: this._visit.mocartScorings.subChondralChangesScore,
        comment: this._visit.mocartScorings.comment,
        totalMocartScore: this._visit.mocartScorings.totalMocartScore,
        icrsGrade: this._visit.mocartScorings.icrsGrade,
        notAvailable: this._visit.mocartScorings.lesionMeasurement?.notAvailable,
        diameterProductValue: this._visit.mocartScorings.diameterProductValue
      });

      if(this.isBaselineVisit) {
        this.mocartFormControl.patchValue({
          ladValue: this._visit.mocartScorings.lesionMeasurement?.ladValue ?? null,
          sadValue: this._visit.mocartScorings.lesionMeasurement?.sadValue ?? null,

          diameterValue1: this._visit.mocartScorings.lesionMeasurement?.diameterValue ?? null,
          diameterValue2: this._visit.mocartScorings.lesionMeasurement2?.diameterValue ?? null,

          notAvailable1: this._visit.mocartScorings.lesionMeasurement?.notAvailable,
          notAvailable2: this._visit.mocartScorings.lesionMeasurement2?.notAvailable
        });

        if(!this.snapshot1) {
          this.snapshot1 = {};
        }

        if(!this.snapshot2) {
          this.snapshot2 = {};
        }

        this.snapshot1.seriesId = this._visit.mocartScorings.lesionMeasurement?.screenshot?.seriesId;
        this.snapshot1.sliceNumber = this._visit.mocartScorings.lesionMeasurement?.screenshot?.sliceNumber;
        this.snapshot1.bucketName = this._visit.mocartScorings.lesionMeasurement?.screenshot?.bucketName;
        this.snapshot1.storagePath = this._visit.mocartScorings.lesionMeasurement?.screenshot?.storagePath;
        this.snapshot1.storageFileName = this._visit.mocartScorings.lesionMeasurement?.screenshot?.storageFileName;
        this.snapshot1.storageFileNamePreview = this._visit.mocartScorings.lesionMeasurement?.screenshot?.storageFileNamePreview;
        this.snapshot1.modalityName = this._visit.mocartScorings.lesionMeasurement?.screenshot?.modalityName;
        this.snapshot1.sequenceLabelName = this._visit.mocartScorings.lesionMeasurement?.screenshot?.sequenceLabelName;

        this.snapshot2.seriesId = this._visit.mocartScorings.lesionMeasurement2?.screenshot?.seriesId;
        this.snapshot2.sliceNumber = this._visit.mocartScorings.lesionMeasurement2?.screenshot?.sliceNumber;
        this.snapshot2.bucketName = this._visit.mocartScorings.lesionMeasurement2?.screenshot?.bucketName;
        this.snapshot2.storagePath = this._visit.mocartScorings.lesionMeasurement2?.screenshot?.storagePath;
        this.snapshot2.storageFileName = this._visit.mocartScorings.lesionMeasurement2?.screenshot?.storageFileName;
        this.snapshot2.storageFileNamePreview = this._visit.mocartScorings.lesionMeasurement2?.screenshot?.storageFileNamePreview;
        this.snapshot2.modalityName = this._visit.mocartScorings.lesionMeasurement2?.screenshot?.modalityName;
        this.snapshot2.sequenceLabelName = this._visit.mocartScorings.lesionMeasurement2?.screenshot?.sequenceLabelName;

        this.originalBaselineReadingId = this._visit.mocartScorings.lesionMeasurement?.screenshot?.readingId;

        if(!this.isNotAvailable1()) {
          if(this.originalBaselineReadingId && this.snapshot1.seriesId && this.snapshot1.sliceNumber) {
            this.getSnapshotLink(this.reading.studyId, this.originalBaselineReadingId, this.snapshot1.seriesId, this.snapshot1.sliceNumber, this.lesionNumber1);
          }
        }

        if(!this.isNotAvailable2()){
          if(this.originalBaselineReadingId && this.snapshot2.seriesId && this.snapshot2.sliceNumber) {
            this.getSnapshotLink(this.reading.studyId, this.originalBaselineReadingId, this.snapshot2.seriesId, this.snapshot2.sliceNumber, this.lesionNumber2);
          }
        }
      }
    }
    this.screenshotSubscription = this.readingService.screenshot.subscribe(
      (data) => {
        if (data) {
          this.setScreenShotToImgFromWebsocket(data);
        }
      }
    );
    this.updateFormValidationForVisitType();
  }

  init(): void {
    this.updateFormValidationForVisitType();
    this.formValueChanges();
  }

  formValueChanges() {
    this.form.valueChanges.subscribe(() => {
      const isValid = this.form.valid;
      const baselineConditionOk = !this.isBaselineVisit || this.isBaselineDataValid();
      this.onValidForm.emit({ isValid, baselineConditionOk });
    });
  }

  calculateScore (name: string) {
    if (this.checkIfEmpty(name)) {
      return;
    }
    switch (name) {
      case 'volumeOfCartilageDefectFiling': this.calculateVolumeOfCartilageDefectFilingScore(name);
        break;
      case 'integrationAdjacentCartilage': this.calculateIntegrationAdjacentCartilageScore(name);
        break;
      case 'surfaceRepairTissue': this.calculateSurfaceRepairTissueScore(name);
        break;
      case 'structureRepairTissue': this.calculateStructureRepairTissueScore(name);
        break;
      case 'signalIntensityRepairTissue': this.calculateSignalIntensityRepairTissueScore(name);
        break;
      case 'bonyDefect': this.calculateBonyDefectScore(name);
        break;
      case 'subChondralChanges': this.calculateSubChondralChangesScore(name);
        break;
    }
  }

  calculateVolumeOfCartilageDefectFilingScore(name: string) {
    let score = 0;
    switch (this.form.get(`scorings.${name}`).value) {
      case 'minorHypertrophy':
        score = 20;
        break;
      case 'majorHypertrophy':
        score = 15;
        break;
      case 'under75Filling':
        score = 10;
        break;
      case 'under50Filling':
        score = 5;
        break;
      case 'under25Filling':
        score = 0;
        break;
      default:
        score = 0;
    }
    this.setScore(name, score);
  }

  calculateIntegrationAdjacentCartilageScore(name: string) {
    let score = 0;
    switch (this.form.get(`scorings.${name}`).value) {
      case 'completeIntegration':
        score = 15;
        break;
      case 'under2mm':
        score = 10;
        break;
      case 'over2mmUnder0Percent':
        score = 5;
        break;
      case 'under50Percent':
        score = 0;
        break;
      default:
        score = 0;
    }
    this.setScore(name, score);
  }

  calculateSurfaceRepairTissueScore(name: string) {
    let score = 0;
    switch (this.form.get(`scorings.${name}`).value) {
      case 'surfaceIntact':
        score = 10;
        break;
      case 'surfaceIrregularUnder50Percent':
        score = 5;
        break;
      case 'surfaceIrregularUnderEqualTo50Percent':
        score = 0;
        break;
      default:
        score = 0;
    }
    this.setScore(name, score);
  }

  calculateStructureRepairTissueScore(name: string) {
    let score = 0;
    switch (this.form.get(`scorings.${name}`).value) {
      case 'homogeneous':
        score = 10;
        break;
      case 'inhomogeneous':
        score = 0;
        break;
      default:
        score = 0;
    }
    this.setScore(name, score);
  }

  calculateSignalIntensityRepairTissueScore(name: string) {
    let score = 0;
    switch (this.form.get(`scorings.${name}`).value) {
      case 'normal':
        score = 15;
        break;
      case 'minorAbnormal':
        score = 10;
        break;
      case 'severelyAbnormal':
        score = 0;
        break;
      default:
        score = 0;
    }
    this.setScore(name, score);
  }

  calculateBonyDefectScore(name: string) {
    let score = 0;
    switch (this.form.get(`scorings.${name}`).value) {
      case 'noBonyDefect':
        score = 10;
        break;
      case 'bonyDefectUnder50Percent':
        score = 5;
        break;
      case 'bonyDefectOver50Percent':
        score = 0;
        break;
      default:
        score = 0;
    }
    this.setScore(name, score);
  }

  calculateSubChondralChangesScore(name: string) {
    let score = 0;
    switch (this.form.get(`scorings.${name}`).value) {
      case 'noMajor':
        score = 20;
        break;
      case 'minorEdema':
        score = 15;
        break;
      case 'severeEdema':
        score = 10;
        break;
      case 'subchondralCyst':
        score = 0;
        break;
      default:
        score = 0;
    }
    this.setScore(name, score);
  }

  setScore(name: string, score: number) {
    const scoreName = name + 'Score';
    this.form.get(`scorings.${scoreName}`).setValue(score);
  }

  getScore(name: string) {
    if (!name || !this.form.get(`scorings.${name}`)) {
      return;
    }
    return this.form.get(`scorings.${name}`).value;
  }

  reset(): void {
    ((this.form.get('scorings') as FormArray).controls as FormGroup[]).forEach(control => {
        control.reset();
    });
  }

  calculateTotalMocartScore () {
    const volumeOfCartilageDefectFilingScore = !this.checkIfEmpty('volumeOfCartilageDefectFilingScore') ? this.form.get(`scorings.volumeOfCartilageDefectFilingScore`).value : 0;
    const integrationAdjacentCartilageScore = !this.checkIfEmpty('integrationAdjacentCartilageScore') ? this.form.get(`scorings.integrationAdjacentCartilageScore`).value : 0;
    const surfaceRepairTissueScore = !this.checkIfEmpty('surfaceRepairTissueScore') ? this.form.get(`scorings.surfaceRepairTissueScore`).value : 0;
    const structureRepairTissueScore = !this.checkIfEmpty('structureRepairTissueScore') ? this.form.get(`scorings.structureRepairTissueScore`).value : 0;
    const signalIntensityRepairTissueScore = !this.checkIfEmpty('signalIntensityRepairTissueScore') ? this.form.get(`scorings.signalIntensityRepairTissueScore`).value : 0;
    const bonyDefectScore = !this.checkIfEmpty('bonyDefectScore') ? this.form.get(`scorings.bonyDefectScore`).value : 0;
    const subChondralChangesScore = !this.checkIfEmpty('subChondralChangesScore') ? this.form.get(`scorings.subChondralChangesScore`).value : 0;

    const totalMocartScore = volumeOfCartilageDefectFilingScore + integrationAdjacentCartilageScore + surfaceRepairTissueScore
      + structureRepairTissueScore + signalIntensityRepairTissueScore + bonyDefectScore + subChondralChangesScore;

    this.form.get(`scorings.${`totalMocartScore`}`).setValue(totalMocartScore);
    return totalMocartScore;
  }

  checkIfEmpty(name: string) {
      return !name || !this.form.get(`scorings.${name}`);
  }

  setSubmitData() {
    if (!this.visit.mocartScorings) {

      this.visit.mocartScorings = {};

      if(this.isBaselineVisit ) {

        if(!this.visit.mocartScorings.lesionMeasurement) {
          this.visit.mocartScorings.lesionMeasurement = {};
        }
        if(!this.visit.mocartScorings.lesionMeasurement2) {
          this.visit.mocartScorings.lesionMeasurement2 = {};
        }

        if(!this.visit.mocartScorings.lesionMeasurement.screenshot) {
          this.visit.mocartScorings.lesionMeasurement.screenshot = {};
        }
        if(!this.visit.mocartScorings.lesionMeasurement2.screenshot) {
          this.visit.mocartScorings.lesionMeasurement2.screenshot = {};
        }
      }
    }

    const scorings = this.visit.mocartScorings;

    if(!this.isVisitCompleted()) {
      if(!this.isBaselineVisit) {
        scorings.volumeOfCartilageDefectFiling = this.form.get('scorings.volumeOfCartilageDefectFiling').value;
        scorings.volumeOfCartilageDefectFilingScore = this.form.get('scorings.volumeOfCartilageDefectFilingScore').value;
        scorings.integrationAdjacentCartilage = this.form.get('scorings.integrationAdjacentCartilage').value;
        scorings.integrationAdjacentCartilageScore = this.form.get('scorings.integrationAdjacentCartilageScore').value;
        scorings.surfaceRepairTissue = this.form.get('scorings.surfaceRepairTissue').value;
        scorings.surfaceRepairTissueScore = this.form.get('scorings.surfaceRepairTissueScore').value;
        scorings.structureRepairTissue = this.form.get('scorings.structureRepairTissue').value;
        scorings.structureRepairTissueScore = this.form.get('scorings.structureRepairTissueScore').value;
        scorings.signalIntensityRepairTissue = this.form.get('scorings.signalIntensityRepairTissue').value;
        scorings.signalIntensityRepairTissueScore = this.form.get('scorings.signalIntensityRepairTissueScore').value;
        scorings.bonyDefect = this.form.get('scorings.bonyDefect').value;
        scorings.bonyDefectScore = this.form.get('scorings.bonyDefectScore').value;
        scorings.subChondralChanges = this.form.get('scorings.subChondralChanges').value;
        scorings.subChondralChangesScore = this.form.get('scorings.subChondralChangesScore').value;
        scorings.totalMocartScore = this.form.get('scorings.totalMocartScore').value;
      }

      if(this.isBaselineVisit) {
        scorings.lesionLocation = this.form.get('scorings.lesionLocation').value;
        scorings.icrsGrade = this.form.get('scorings.icrsGrade').value;
        scorings.lesionMeasurement.ladValue = this.form.get('scorings.ladValue')?.value;
        scorings.lesionMeasurement.sadValue = this.form.get('scorings.sadValue')?.value;
        scorings.lesionMeasurement.lad = this.getLad();
        scorings.lesionMeasurement.sad = this.getSad();


        if(!scorings.lesionMeasurement) {
          scorings.lesionMeasurement = {};

          if(!scorings.lesionMeasurement.screenshot) {
            scorings.lesionMeasurement.screenshot = {};
          }
        }

        if(!scorings.lesionMeasurement2) {
          scorings.lesionMeasurement2 = {};

          if(!scorings.lesionMeasurement2.screenshot) {
            scorings.lesionMeasurement2.screenshot = {};
          }
        }

        scorings.lesionMeasurement.screenshot.seriesId = this.snapshot1?.seriesId;
        scorings.lesionMeasurement.screenshot.sliceNumber = this.snapshot1?.sliceNumber;
        scorings.lesionMeasurement.screenshot.bucketName = this.snapshot1?.bucketName;
        scorings.lesionMeasurement.screenshot.storagePath = this.snapshot1?.storagePath;
        scorings.lesionMeasurement.screenshot.storageFileName = this.snapshot1?.storageFileName;
        scorings.lesionMeasurement.screenshot.storageFileNamePreview = this.snapshot1?.storageFileNamePreview;
        scorings.lesionMeasurement.screenshot.modalityName = this.snapshot1?.modalityName;
        scorings.lesionMeasurement.screenshot.sequenceLabelName = this.snapshot1?.sequenceLabelName;
        scorings.lesionMeasurement.notAvailable = this.form.get('scorings.notAvailable1')?.value;
        scorings.lesionMeasurement.diameterValue = this.form.get('scorings.diameterValue1')?.value;
        scorings.lesionMeasurement.diameter = this.getDiameter1();


        scorings.lesionMeasurement2.screenshot.seriesId = this.snapshot2?.seriesId;
        scorings.lesionMeasurement2.screenshot.sliceNumber = this.snapshot2?.sliceNumber;
        scorings.lesionMeasurement2.screenshot.bucketName = this.snapshot2?.bucketName;
        scorings.lesionMeasurement2.screenshot.storagePath = this.snapshot2?.storagePath;
        scorings.lesionMeasurement2.screenshot.storageFileName = this.snapshot2?.storageFileName;
        scorings.lesionMeasurement2.screenshot.storageFileNamePreview = this.snapshot2?.storageFileNamePreview;
        scorings.lesionMeasurement2.screenshot.modalityName = this.snapshot2?.modalityName;
        scorings.lesionMeasurement2.screenshot.sequenceLabelName = this.snapshot2?.sequenceLabelName;
        scorings.lesionMeasurement2.notAvailable = this.form.get('scorings.notAvailable2')?.value;
        scorings.lesionMeasurement2.diameterValue = this.form.get('scorings.diameterValue2')?.value;
        scorings.lesionMeasurement2.diameter = this.getDiameter2();

        scorings.diameterProductValue = this.getDiameterProductValue();
        scorings.diameterProduct = this.getDiameterProduct();

        if(!this.originalBaselineReadingId) {
          scorings.lesionMeasurement.screenshot.readingId = this.reading.id;
          scorings.lesionMeasurement2.screenshot.readingId = this.reading.id;
        }
      }
      scorings.comment = this.form.get('scorings.comment').value;
    }

    console.log('Mocart Scoring -> ', scorings);
  }

  get isBaselineVisit(): boolean {
    return this.baselineVisitConfigId === this.visit.visitConfigId;
  }

  updateFormValidationForVisitType(): void {
    const scoringControls = this.form.get('scorings') as FormGroup;

    // All scoring control names with conditional validators
    const baselineControls = ['lesionLocation','icrsGrade'];
    const nonBaselineControls = [
      'volumeOfCartilageDefectFiling',
      'volumeOfCartilageDefectFilingScore',
      'integrationAdjacentCartilage',
      'integrationAdjacentCartilageScore',
      'surfaceRepairTissue',
      'surfaceRepairTissueScore',
      'structureRepairTissue',
      'structureRepairTissueScore',
      'signalIntensityRepairTissue',
      'signalIntensityRepairTissueScore',
      'bonyDefect',
      'bonyDefectScore',
      'subChondralChanges',
      'subChondralChangesScore',
      'totalMocartScore'
    ];

    // Clear validators on all controls first
    [...baselineControls, ...nonBaselineControls].forEach(controlName => {
      const control = scoringControls.get(controlName);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });

    // Set validators based on visit type
    if (this.isBaselineVisit) {
      baselineControls.forEach(controlName => {
        const control = scoringControls.get(controlName);
        if (control) {
          control.setValidators([Validators.required]);
          control.updateValueAndValidity();
        }
      });
    } else {
      nonBaselineControls.forEach(controlName => {
        const control = scoringControls.get(controlName);
        if (control) {
          control.setValidators([Validators.required]);
          control.updateValueAndValidity();
        }
      });
    }
  }

  public get editType(): typeof OncologyLesionEditType {
    return OncologyLesionEditType;
  }

  onEditMeasurement(editType?: OncologyLesionEditType, lesionName?: string) {

    if(lesionName === this.lesionName1) {
      this.form.get('scorings.notAvailable1').setValue(false);
    } else if(lesionName === this.lesionName2) {
      this.form.get('scorings.notAvailable2').setValue(false);
    }

    const requestData: AddLesionRequest = {
      readingId: this.reading.id,
      visitId: this.visit?.id,
      visitConfigId: this.visit?.visitConfigId,
      lesionType: this.lesionType,
      markerType: this.ruler,
      lesionName: lesionName
    };

    const request: OncologyAddLesionData = {
      requestedData: requestData,
      editType: null,
      edit: false,
      data: null,
    };

    this.notifyAddLesion(request);
  }

  notifyAddLesion(event: OncologyAddLesionData) {
    this.addUpdateLesionRequest = event;
    if (this.onAddLesion) {
      this.onAddLesion.emit(event.requestedData);
    }
  }

  confirmLesion(marker) {
    if (this.addUpdateLesionRequest) {
      this.addUpdateLesionRequest.viewerData = marker;
      this.processLesionData(this.addUpdateLesionRequest);
    }
  }

  processLesionData(sentData: OncologyAddLesionData) {
    const lesionName = sentData.requestedData.lesionName;
    this.currentLesion = lesionName === this.lesionName1 ? this.lesionNumber1 : this.lesionNumber2;
    if(this.currentLesion === this.lesionNumber1) {
      this.form.get('scorings.diameterValue1')?.setValue(sentData.viewerData.diam);
    } else if(this.currentLesion === this.lesionNumber2) {
      this.form.get('scorings.diameterValue2')?.setValue(sentData.viewerData.diam);
    }
    this.attachImage();
  }

  getDiameter1(): string {
    const diameter1 = this.form.get('scorings.diameterValue1')?.value;
    return (diameter1 !== null && diameter1 !== undefined && !isNaN(diameter1)) ? Number(diameter1).toFixed(2) : 'N/A';
  }

  getDiameter2(): string {
    const diameter2 = this.form.get('scorings.diameterValue2')?.value;
    return (diameter2 !== null && diameter2 !== undefined && !isNaN(diameter2)) ? Number(diameter2).toFixed(2) : 'N/A';
  }

  getDiameterProductValue(): number {
    const diameterProduct: number = (Number(this.getDiameter1()) * Number(this.getDiameter2()));
    return !isNaN(diameterProduct) ? diameterProduct : null;
  }

  getDiameterProduct(): string {
    return (!this.getDiameterProductValue() || this.getDiameterProductValue()?.toFixed(2) === 'NaN') ? 'N/A' : (this.getDiameterProductValue()?.toFixed(2));
  }

  getDiameterProductUnit(): string {
    return !this.getDiameterProductValue() ? '' :
      (this.getDiameterProductValue()?.toFixed(2) === 'NaN' ?  '' : ' mm\u00B2');
  }

  getLad(): string {
    const lad = this.form.get('scorings.ladValue')?.value;
    return (lad !== null && lad !== undefined && !isNaN(lad)) ? Number(lad).toFixed(2) : 'N/A';
  }

  getSad(): string {
    const sad = this.form.get('scorings.sadValue')?.value;
    return (sad !== null && sad !== undefined && !isNaN(sad)) ? Number(sad).toFixed(2) : 'N/A';
  }

  attachImage() {
    this.readingService.requestScreenshotData();
  }

  setScreenShotToImgFromWebsocket(snapshot: any) {

    const screenshotData = {
      seriesId: snapshot.cellInfo.seriesId,
      image: snapshot.image,
      preview: snapshot.image,
      sopInstanceUid: snapshot.cellInfo.seriesUID,
      sliceNumber: snapshot.sliceNum + 1,
      modalityName: snapshot.cellInfo.modality,
      sequenceLabelName: snapshot.cellInfo.label,
      lesionNumber: this.currentLesion
    }

    if(this.currentLesion === this.lesionNumber1) {
      this.lesionData.screenShotData1 = screenshotData;

      if(!this.isVisitCompleted() && !this.isNotAvailable1()) {
        this.saveImage(this.lesionData.screenShotData1);
      }
    } else if(this.currentLesion === this.lesionNumber2) {
      this.lesionData.screenShotData2 = screenshotData;
      if(!this.isVisitCompleted() && !this.isNotAvailable2()) {
        this.saveImage(this.lesionData.screenShotData2);
      }
    }
  }

  saveImage(screenShotData: any){
    this.saveImageToCloud(screenShotData);
  }

  saveImageToCloud(screenShotData: {
    image: string;
    preview: string;
    seriesId: number;
    sliceNumber: number;
    modalityName: string;
    sequenceLabelName: string;
    sopInstanceUid: string;
    lesionNumber: number;
  }) {

    const contentType = 'image/jpeg'; // You could also detect this dynamically

    // Remove base64 prefix and convert to Blob
    const imageBase64 = screenShotData.image?.split(',')[1];
    const previewBase64 = screenShotData.preview?.split(',')[1];

    const imageBlob = this.b64toBlob(imageBase64, contentType);
    const previewBlob = this.b64toBlob(previewBase64, contentType);

    if(imageBlob && previewBlob) {
      this.readingService
        .getSnapshotUploadLink(
          this.reading.studyId,
          this.reading.id,
          screenShotData.seriesId,
          screenShotData.sliceNumber,
          this.currentLesion
        )
        .subscribe(
          (response) => {
            // Upload both blobs to cloud
            forkJoin([
              this.readingService.uplodFileToCloud(response.data.uploadFileUrl, imageBlob),
              this.readingService.uplodFileToCloud(response.data.uploadFileUrlPreview, previewBlob)
            ]).subscribe(
              ([imgUploadRes, imgPreviewUploadRes]) => {
                const snapshot = new Snapshot();
                snapshot.seriesId = screenShotData.seriesId;
                snapshot.sliceNumber = screenShotData.sliceNumber;
                snapshot.storageFileName = response.data.storageFileName;
                snapshot.storageFileNamePreview = response.data.storageFileNamePreview;
                snapshot.bucketName = response.data.bucketName;
                snapshot.storagePath = response.data.storagePath;
                snapshot.fileUrl = response.data.fileUrl;
                snapshot.fileUrlPreview = response.data.fileUrlPreview;
                snapshot.modalityName = screenShotData.modalityName;
                snapshot.sequenceLabelName = screenShotData.sequenceLabelName;
                snapshot.sopInstanceUid = screenShotData.sopInstanceUid;
                //this.showModalSpinnerLoadingData = false;
                //this.snapshot = snapshot;

                if(this.currentLesion === this.lesionNumber1) {
                  this.snapshot1 = snapshot;
                } else if(this.currentLesion === this.lesionNumber2) {
                  this.snapshot2 = snapshot;
                }
              },
              () => {
                this.toastService.error('Unexpected error', 'Something went wrong. Try again or contact support team.');
              }
            );
          },
          () => {
            this.toastService.error('Unexpected error', 'Something went wrong. Try again or contact support team.');
          }
        );
    }
  }

  private b64toBlob(b64Data: string, contentType: string, sliceSize = 512): Blob {

    if(b64Data) {
      const byteCharacters = window.atob(b64Data);
      const byteArrays: Uint8Array[] = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays || [], { type: contentType });
    }
    return null;
  }

  onShowImage(lesionName : string) {

    let snapshot: any;

    if(lesionName === this.lesionName1) {
      snapshot = this.snapshot1;
    } else if(lesionName === this.lesionName2) {
      snapshot = this.snapshot2;
    }

    if(snapshot && snapshot.fileUrl) {
      let title = "There is no image to preview";
      let message = "";
      title = 'Lesion: ' + lesionName + ',  Modality: ' + snapshot.modalityName
        + ', Label: ' + snapshot.sequenceLabelName
        + ', Slice: ' + snapshot.sliceNumber;
      message = '<img width="100%" src="' + snapshot.fileUrl + '"/>';

      const dialogMessaegRef = this.dialogMessagePreview.open(MessageDialogComponent, {
        disableClose: true,
        data: {title: title, message: message, html: true}
      });

      dialogMessaegRef.afterClosed().subscribe(result => { });
    }
  }

  onNotAvailable1(event: any) {

    if(event.checked) {
      if (!this.snapshot1) {
        this.snapshot1 = {};
      }

      this.form.get('scorings.diameterValue1').setValue(null);

      this.snapshot1.seriesId = null;
      this.snapshot1.sliceNumber = null;
      this.snapshot1.storageFileName = null;
      this.snapshot1.storageFileNamePreview = null;
      this.snapshot1.bucketName = null;
      this.snapshot1.storagePath = null;
      this.snapshot1.fileUrl = null;
      this.snapshot1.fileUrlPreview = null;
      this.snapshot1.modalityName = null;
      this.snapshot1.sequenceLabelName = null;
      this.snapshot1.sopInstanceUid = null;
    }
  }

  onNotAvailable2(event: any) {

    if(event.checked) {

      if (!this.snapshot2) {
        this.snapshot2 = {};
      }

      this.form.get('scorings.diameterValue2').setValue(null);

      this.snapshot2.seriesId = null;
      this.snapshot2.sliceNumber = null;
      this.snapshot2.storageFileName = null;
      this.snapshot2.storageFileNamePreview = null;
      this.snapshot2.bucketName = null;
      this.snapshot2.storagePath = null;
      this.snapshot2.fileUrl = null;
      this.snapshot2.fileUrlPreview = null;
      this.snapshot2.modalityName = null;
      this.snapshot2.sequenceLabelName = null;
      this.snapshot2.sopInstanceUid = null;
    }
  }

  getSnapshotLink(studyId: any, readingId: any, seriesId: any, sliceNumber: any, lesionNumber: any) {

    this.readingService
      .getSnapshotUploadLink(
        studyId,
        readingId,
        seriesId,
        sliceNumber,
        lesionNumber
      )
      .subscribe(
        (response) => {

          if(lesionNumber === this.lesionNumber1) {
            this.snapshot1.fileUrl = response.data.fileUrl;
            this.snapshot1.fileUrlPreview = response.data.fileUrlPreview;
          } else if(lesionNumber === this.lesionNumber2) {
            this.snapshot2.fileUrl = response.data.fileUrl;
            this.snapshot2.fileUrlPreview = response.data.fileUrlPreview;
          }
        },
        (error) => {
          this.toastService.error('Unexpected error', 'Something went wrong. Try again or contact support team.');
          console.error('Error fetching snapshot upload link:', error);
        }
      );
  }

  disableCompletedVisit() {
    if(this.isVisitCompleted()) {

      // baseline visit fields
      this.form.get('scorings.lesionLocation')?.disable();
      this.form.get('scorings.icrsGrade')?.disable();
      this.form.get('scorings.notAvailable')?.disable();
      this.form.get('scorings.notAvailable1')?.disable();
      this.form.get('scorings.notAvailable2')?.disable();

      // follow up visit fields
      this.form.get('scorings.volumeOfCartilageDefectFiling')?.disable();
      this.form.get('scorings.volumeOfCartilageDefectFilingScore')?.disable();
      this.form.get('scorings.integrationAdjacentCartilage')?.disable();
      this.form.get('scorings.integrationAdjacentCartilageScore')?.disable();
      this.form.get('scorings.surfaceRepairTissue')?.disable();
      this.form.get('scorings.surfaceRepairTissueScore')?.disable();
      this.form.get('scorings.structureRepairTissue')?.disable();
      this.form.get('scorings.structureRepairTissueScore')?.disable();
      this.form.get('scorings.signalIntensityRepairTissue')?.disable();
      this.form.get('scorings.signalIntensityRepairTissueScore')?.disable();
      this.form.get('scorings.bonyDefect')?.disable();
      this.form.get('scorings.bonyDefectScore')?.disable();
      this.form.get('scorings.subChondralChanges')?.disable();
      this.form.get('scorings.subChondralChangesScore')?.disable();
      this.form.get('scorings.totalMocartScore')?.disable();

      this.form.get('scorings.comment')?.disable();
    }
  }

  isVisitCompleted() {
    return this.visit.status === 'DONE';
  }

  isNotAvailable(): boolean {
    return this.form.get('scorings.notAvailable')?.value;
  }

  isNotAvailable1(): boolean {
    return this.form.get('scorings.notAvailable1')?.value;
  }

  isNotAvailable2(): boolean {
    return this.form.get('scorings.notAvailable2')?.value;
  }

  ladValue(): number {
    return this.form.get('scorings.ladValue')?.value;
  }

  sadValue(): number {
    return this.form.get('scorings.sadValue')?.value;
  }

  isBaselineDataValid(): boolean {
    const diameterValue1 = this.form.get('scorings.diameterValue1')?.value;
    const diameterValue2 = this.form.get('scorings.diameterValue2')?.value;
    const notAvailable1 = this.form.get('scorings.notAvailable1')?.value;
    const notAvailable2 = this.form.get('scorings.notAvailable2')?.value;

    const diameterValue1Check = diameterValue1 != null && diameterValue1 !== undefined && !isNaN(diameterValue1);
    const diameterValue2Check = diameterValue2 != null && diameterValue2 !== undefined && !isNaN(diameterValue2);

    return (this.isNotAvailable1() || diameterValue1Check) && (this.isNotAvailable2() || diameterValue2Check);
  }
}
